import type { Configuration } from '@creditas/event-track';
import type { ProductType } from '~/shared/domain/models';

export const productBu: Record<ProductType, Configuration['bu']> = {
  AUTO_EQUITY: 'AE',
  AUTO_FINANCING: 'AF',
  AUTO_SELLING: 'CAC2C',
  BENEFITS: 'BE',
  CROSS: 'CR',
  CROSS_EQUITY: 'CR',
  HOME_EQUITY: 'HE',
  HOME_FINANCING: 'HF',
  HOME_SOLUTIONS: 'HS',
  INSURANCE: 'IS',
  INVESTOR_RELATION: 'IN',
};
